import { ButtonProps as RadixButtonProps } from '@radix-ui/themes';

import { FlyThemeColor } from '../utils';

type ButtonSize = '0' | '1' | '2' | '3' | '4';

export type ButtonProps = Omit<RadixButtonProps, 'color' | 'size'> & {
  color?: FlyThemeColor;
  size?: ButtonSize;
  iconStart?: React.ReactNode | string;
  iconEnd?: React.ReactNode | string;
  iconSize?: number;
  to?: string;
  href?: string;
  target?: string;
  /** When true, suppresses hover and active background regardless of variant. */
  noHoverEffect?: boolean;
};

export const radiusMap: Record<
  `${ButtonSize}-${NonNullable<RadixButtonProps['radius']>}`,
  string
> = {
  '0-none': 'rounded-none',
  '0-small': 'rounded-fly-3',
  '0-medium': 'rounded-fly-3',
  '0-large': 'rounded-fly-3',
  '0-full': 'rounded-full',

  '1-none': 'rounded-none',
  '1-small': 'rounded-fly-3',
  '1-medium': 'rounded-fly-3',
  '1-large': 'rounded-fly-3',
  '1-full': 'rounded-full',

  '2-none': 'rounded-none',
  '2-small': 'rounded-fly-3',
  '2-medium': 'rounded-fly-3',
  '2-large': 'rounded-fly-3',
  '2-full': 'rounded-full',

  '3-none': 'rounded-none',
  '3-small': 'rounded-fly-4',
  '3-medium': 'rounded-fly-4',
  '3-large': 'rounded-fly-4',
  '3-full': 'rounded-full',

  '4-none': 'rounded-none',
  '4-small': 'rounded-fly-4',
  '4-medium': 'rounded-fly-4',
  '4-large': 'rounded-fly-4',
  '4-full': 'rounded-full',
};

export const sizeToStyleMap: Record<ButtonSize, string> = {
  '0': 'text-size-fly-1 h-[18px] px-fly-2 py-fly-1',
  '1': 'text-size-fly-1 h-6',
  '2': 'text-size-fly-2 h-8 px-fly-4',
  '3': 'text-size-fly-3 h-10 px-fly-5',
  '4': 'text-size-fly-4 h-12 px-fly-6',
};

export const iconSizeMap: Record<ButtonSize, number> = {
  '0': 12,
  '1': 16,
  '2': 16,
  '3': 20,
  '4': 24,
};

export const sizeToRadixSizeMap: Record<ButtonSize, RadixButtonProps['size']> =
  {
    '0': '1',
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
  };

export const BUTTON_FIGMA_URL =
  'https://www.figma.com/design/Svhsw3mzAIBPXPL3w2cm0a/Radix--JFrog-Fly-Design-System?node-id=1230-17452&m=dev';
